/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

@use '../../../variables';

.AllPatientRecordsDialog {
  .MuiPaper-root {
    width: 1080px;
    max-width: 1080px;
    max-height: 740px;
  }

  .title {
    display: flex;
    align-content: center;
    justify-content: space-between;
  }

  .MuiDialogActions-root {
    padding-top: variables.$padding-large;
  }
}
